import React, { useEffect } from "react"
import { Downgraded, useHookstate } from "@hookstate/core"
import SearchIcon from '@mui/icons-material/Search';
import { Button, CircularProgress, Grid, IconButton, Tooltip } from "@mui/material"
import FilterAutocompleteLocationAccuracy from "~/components/FilterAutocompleteLocationAccuracy"
import { useLang } from "~/hooks/useLang"
import SelectBasic from "~/components/SelectBasic";
import { getMarkersFilteredHeatMapDispatchsService } from "~/features/Map/services/request";
import { useMarkerState } from "~/features/Map/stores/MapState";
import useSystemState from "~/features/System/stores/SystemState";

export default function FilterDispatchHotMap({ expandFilterSearch, locationAccuracy, refreshHotMap, selectIsValidatedTypeMap, loading, heatMapDispatchs, showHeatMap, refresh }) {
  const { translate } = useLang()
  const { markersState } = useMarkerState()
  const { windowManager } = useSystemState()
  const optionsSelectTypeMap = useHookstate([
    { id: 1, name: `${translate('Heat Map')}` },
    { id: 2, name: `${translate('Dispatch Map')}` },
  ])
  
  useEffect(() => {
    markersState()['dispatchHeatMap']?.set({})
    if (selectIsValidatedTypeMap.get() === '2') {
      locationAccuracy.set([])
      getMarkersFilteredHeatMapDispatchsService(heatMapDispatchs)
        .then((responseData) => {
          markersState()['dispatchHeatMap']?.set(responseData)
        }).finally(() => {
          showHeatMap.set(false)
          windowManager()['mapSetting']['markersView']['dispatchHeatMap'].show.set(true)
        })
    } else {
      showHeatMap.set(true)
      windowManager()['mapSetting']['markersView']['dispatchHeatMap'].show.set(false)
    }

  }, [refreshHotMap.get(), refresh]);

  const handleClearFilters = () => {
    locationAccuracy.set([])
    selectIsValidatedTypeMap.set('1')
    refreshHotMap.set(!refreshHotMap.get())
  }

  return (
    <Grid
      xs={12}
      hidden={!expandFilterSearch}
      flex={1}
      container
      spacing={2}
      marginTop={1}
      alignItems={'end'}>
      <Grid item xs={3}>
        <SelectBasic
          state={selectIsValidatedTypeMap}
          options={optionsSelectTypeMap.get()}
          placeholder={translate('Type Map')}
          size={'small'}
          disabled={false}
        />
      </Grid>
      {selectIsValidatedTypeMap.get() === '1' &&
        <Grid item xs={3} >
          <FilterAutocompleteLocationAccuracy
            onAccuracyChange={(accuracy) => locationAccuracy.set(accuracy)}
            locationAccuracy={locationAccuracy.attach(Downgraded).get()}
          />
        </Grid>
      }
      <Grid item xs={2}>
        <Button
          variant="text"
          sx={{
            height: '40px',
            textTransform: 'none',
            textDecorationLine: 'underline',
            color: 'text.primary',
            ':hover': {
              bgcolor: 'transparent',
              color: 'primary.main'
            }
          }}
          onClick={() => {
            handleClearFilters()
          }}>
          {translate('Clear Filters')}
        </Button>
        <Tooltip title={translate('Search')} placement="bottom">
          <IconButton
            onClick={() => refreshHotMap.set(!refreshHotMap.get())}
            disabled={loading.get()}
          >
            {loading.get() ? <CircularProgress size={20} /> : <SearchIcon />}
          </IconButton>
        </Tooltip>

      </Grid>
    </Grid>
  )
}